class RequestForteExchangeUrl {
	static protocol = {}

	constructor() {}
}

export default RequestForteExchangeUrl
